import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { isHex } from "@/lib/forumColors";

/** Hex box with a full-spectrum picker: pick a colour, the hex lands in the field. */
export const ColorField = ({ value, onChange, onApply, testId = "color-field" }) => {
  const [hex, setHex] = useState(value || "");

  useEffect(() => {
    setHex(value || "");
  }, [value]);

  const swatch = isHex(hex) ? hex : isHex(value) ? value : "#1D4ED8";

  const commit = (next) => {
    setHex(next);
    if (isHex(next)) onChange?.(next.toUpperCase());
  };

  return (
    <div className="flex items-center gap-2">
      <label
        title="Pick any colour"
        className="relative h-10 w-12 shrink-0 rounded-sm border border-border cursor-pointer overflow-hidden transition-transform duration-200 hover:scale-105"
        style={{ background: swatch }}
      >
        <input
          type="color"
          data-testid={`${testId}-picker`}
          value={swatch}
          onChange={(e) => commit(e.target.value.toUpperCase())}
          className="absolute -inset-2 h-[calc(100%+1rem)] w-[calc(100%+1rem)] cursor-pointer opacity-0"
        />
      </label>
      <Input
        data-testid={`${testId}-input`}
        value={hex}
        onChange={(e) => commit(e.target.value)}
        placeholder="#1D4ED8"
        className="rounded-sm h-10 w-28 text-sm font-mono"
      />
      {onApply ? (
        <Button
          variant="outline"
          data-testid={`${testId}-apply`}
          onClick={() =>
            isHex(hex) ? onApply(hex.toUpperCase()) : toast.error("Use a hex colour like #1D4ED8")
          }
          className="rounded-sm h-10 px-4"
        >
          Apply
        </Button>
      ) : null}
    </div>
  );
};
